//Old
import { APP_NAME, $html, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';
import { EVENT as SCROLL_EVENT } from './Scroll';

const MODULE_NAME = 'News';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    SET_ACTIVE: `setActive.${EVENT_NAMESPACE}`
};

const CLASS = {
    OPEN: 'is-open'
}

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.currentId = options.current;
        this.$items = $('.js-news-item', this.$el);

    }

    init() {

        this.setActive(this.currentId);

        $document.on(EVENT.SET_ACTIVE,(e) => this.setActive(e.id));
        $document.on(SCROLL_EVENT.SCROLLING,(e) => this.updateScroll(e.scroll));

        if(this.$el.find('.js-news-item.is-active').length > 0) {
            $('.js-aside').animate({ scrollTop: this.$el.find('.js-news-item.is-active').offset().top - $('.js-breadcrumb-header').height() });
        }

    }

    setActive(id) {

        this.$el.find('.js-news-item.is-active').removeClass('is-active');

        for (var i = this.$items.length - 1; i >= 0; i--) {
            if($(this.$items[i]).attr('data-id') === id) {
                $(this.$items[i]).addClass('is-active');
            }
        }

        this.$indicator = $('.js-news-item.is-active .js-indicator', this.$el);
        this.$indicator.css({
            '-webkit-transform': `scaleX(0)`,
            '-ms-transform': `scaleX(0)`,
            'transform': `scaleX(0)`
        })
    }

    updateScroll(scroll) {

        this.$indicator.css({
            '-webkit-transform': `scaleX(${scroll.y / scroll.limit})`,
            '-ms-transform': `scaleX(${scroll.y / scroll.limit})`,
            'transform': `scaleX(${scroll.y / scroll.limit})`
        })

    }

    // loadNews(e) {
    //     e.preventDefault();

    //     const $target = $(e.currentTarget);
    //     const href = $target.attr('href');

    //     this.setLoading();

    //     this.$el.find('.js-news-link.is-active').removeClass('is-active');
    //     $target.addClass('is-active');

    //     fetch(href)
    //         .then(response => response.text())
    //         .then(data => {
    //             this.setLoaded();
    //             var el = document.createElement( 'html' );
    //             el.innerHTML = data;

    //             const article = $(el).find('.c-news');
    //             $('.c-main').empty().html(article);

    //             const title = $(el).find('title').html();
    //             $('title').empty().append(title);

    //             const stateObj = {};
    //             history.pushState(stateObj, title, href);
    //         });
    // }

    // setLoading() {
    //     $html.addClass('has-news-loading').removeClass('has-breadcrumb-open');

    //     if ($html.hasClass('has-smooth-scroll')) {
    //         $('.js-scroll').triggerHandler({
    //             type: 'scrollTo.LocomotiveScroll',
    //             options: {
    //                 speed: 900
    //             }
    //         })
    //     } else {
    //         $('html, body').animate({ scrollTop: 0 });
    //     }
    // }

    // setLoaded() {
    //     $html.removeClass('has-news-loading');
    // }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
        $document.off(`.${EVENT_NAMESPACE}`);
    }
}

